import { $http } from "@/assets/js/appFunc";

export const getMultiFeaturesOption = (store) => new Promise((resolve, reject) => {
    $http({
        url: "/identity/featureLogin/extraData",
        type: "POST",
        data: ["ALLOW_MULTILANGUAGE", "SIGNUP", "ACCESSIBILITY", "ENABLE_AI", "ENABLE_ASSISTANT"]
    }, true).then(rsp => {
        const multiLanguageObj = rsp.data.find(item => item.code === "ALLOW_MULTILANGUAGE");
        store.commit("setShowMultiLangOption", (multiLanguageObj && multiLanguageObj.enabled) || false);
        const accessibilityObj = rsp.data.find(item => item.code === "ACCESSIBILITY");
        store.commit("setShowAccessibilityOption", (accessibilityObj && accessibilityObj.enabled) || false);
        const enableAIObj = rsp.data.find(item => item.code === "ENABLE_AI");
        store.commit("setShowEnableAI", (enableAIObj && enableAIObj.enabled) || false);
        const enableTaskAIObj = rsp.data.find(item => item.code === "ENABLE_ASSISTANT");
        store.commit("setShowEnableTaskAI", (enableTaskAIObj && enableTaskAIObj.enabled) || false);
        resolve(rsp);
    }).catch(e => {
        reject(e);
    });
});

export const actGetMainHelpCenter = () => {
    const params = {
        type: "GET",
        url: "/engine/api/web-help/categories/main-categories"
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => resolve(data),
            error => reject(error)
        );
    });
};

export const actGetCategoriesHelpCenter = (store, data) => {
    const params = {
        type: "GET",
        url: `/engine/api/web-help/categories/${data.id}/subcategories?pageNumber=${data.pageNumber}&pageSize=${data.pageSize}`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            response => resolve(response),
            error => reject(error)
        );
    });
};
export const actBrandName = (store) => {
    const req = {
        type: "GET",
        url: "/identity/companyInfo/companyNameAndColorCode"
    };

    return new Promise((resolve, reject) => {
        $http(req, true).then(
            response => {
                const { data = "Aurachain" } = response || {};
                if (typeof data === "object") {
                    store.commit("setInfoApp", data);
                }
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const checkJWT = () => {
    const req = {
        type: "POST",
        url: "/identity/auth/credentials/check"
    };

    return $http(req, true);
};

export const getPlatformVersion = () => {
    const params = {
        type: "GET",
        url: "/general/versions"
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => resolve(data),
            error => reject(error)
        );
    });
};

export const actBackendLicenses = () => {
    const req = {
        type: "GET",
        url: "/gateway/licenses"
    };
    return $http(req, true);
};

export const actFrontendLicenses = () => {
    const req = {
        type: "GET",
        url: "/general/licenses"
    };
    return $http(req, true);
};

export const actMaintenanceActive = () => {
    const req = {
        type: "GET",
        url: "/platform/maintenance/active"
    };
    return $http(req, true);
};

export const actMaintenanceSchedule = () => {
    const req = {
        type: "GET",
        url: "/platform/maintenance/current"
    };
    return $http(req, true);
};

export const checkValidTenant = () => {
    const req = {
        type: "GET",
        url: "/identity/public/checkTenant",
        noNotify: true
    };
    return $http(req, true);
};

export const apiLogs = (context, payload) => {
    const req = {
        type: "POST",
        url: "/audit/integration/export/csv",
        data: payload
    };

    return $http(req, true);
};

export const securityLogs = (context, payload) => {
    const req = {
        type: "POST",
        url: "/audit/security/export/csv",
        data: payload
    };

    return $http(req, true);
};

export const attachmentLogs = (context, payload) => {
    const req = {
        type: "POST",
        url: "/audit/attachment/export/csv",
        data: payload
    };
    return $http(req, true);
};

export const getLegacyClient = () => {
    const req = {
        type: "GET",
        url: "/platform/features/legacy/datastore"
    };

    return $http(req, true);
};
